/**
 * Item de Navegação do Sistema MEDICARE
 * Componente para itens da sidebar
 */

import React, { ReactNode } from 'react';
import {
  Flex,
  Icon,
  Link,
  useColorModeValue,
  FlexProps,
} from '@chakra-ui/react';
import { IconType } from 'react-icons';
import { Link as RouterLink, useLocation } from 'react-router-dom';

interface NavItemProps extends FlexProps {
  icon: IconType;
  path: string;
  children: ReactNode;
}

export const NavItem: React.FC<NavItemProps> = ({ icon, path, children, ...rest }) => {
  const location = useLocation();
  const isActive = location.pathname === path;
  
  const textColor = useColorModeValue('gray.600', 'gray.300');
  const hoverBg = useColorModeValue('gray.100', 'gray.700');
  const activeBg = useColorModeValue('medicare.50', 'medicare.900');
  const activeColor = useColorModeValue('medicare.600', 'medicare.200');
  const hoverTextColor = useColorModeValue('gray.900', 'white');

  return (
    <Link
      as={RouterLink}
      to={path}
      style={{ textDecoration: 'none' }}
      _focus={{ boxShadow: 'none' }}
    >
      <Flex
        align="center"
        p="4"
        mx="4"
        borderRadius="lg"
        role="group"
        cursor="pointer"
        bg={isActive ? activeBg : 'transparent'}
        color={isActive ? activeColor : textColor}
        fontWeight={isActive ? 'semibold' : 'normal'}
        _hover={{
          bg: isActive ? activeBg : hoverBg,
          color: isActive ? activeColor : hoverTextColor,
        }}
        transition="all 0.2s"
        {...rest}
      >
        {icon && (
          <Icon
            mr="4"
            fontSize="16"
            as={icon}
          />
        )}
        {children}
      </Flex>
    </Link>
  );
};

export default NavItem;